/*
 * VDC PDP recommendations v2 - "You may also like" in the buy box column, in the exact
 * slot Rebuy's "You Deserve More" (widget 216844) used to occupy. Dynamic recs from
 * Shopify's Recommendations API, filtered (sold out, protection products, self).
 * v2: 6 products in a horizontal scroll-snap carousel (see vdc-pdp-recs.css).
 * Add buttons post a plain /cart/add.js; the cart guard's fallback opens the native
 * drawer and refreshes it, so no event wiring is needed here.
 */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var EXCLUDE = ['free-returns-package-protection', 'package-protection'];
  var busy = {};

  function money(c) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(c);
    return '$' + (Number(c || 0) / 100).toFixed(2);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function escA(s) { return esc(s).replace(/'/g, '&#39;'); }
  function sized(src, w) { return (typeof src === 'string') ? src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2') : ''; }

  function avail(p) { return (p.variants || []).filter(function (v) { return v.available; }); }

  function card(p) {
    var vars = avail(p);
    var v = vars[0];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var picker = '';
    if (vars.length > 1) {
      picker = '<select class="vdc-pdp-rec__variant" aria-label="Choose size for ' + escA(p.title) + '">' +
        vars.map(function (vv) { return '<option value="' + escA(vv.id) + '" data-price="' + escA(vv.price) + '">' + esc(vv.title) + '</option>'; }).join('') +
        '</select>';
    }
    return '<div class="vdc-pdp-rec" data-product="' + escA(p.id) + '">' +
      '<a class="vdc-pdp-rec__media" href="' + escA(p.url) + '" tabindex="-1">' +
      (img ? '<img loading="lazy" src="' + escA(sized(img, 360)) + '" alt="">' : '') + '</a>' +
      '<a class="vdc-pdp-rec__title" href="' + escA(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="vdc-pdp-rec__price">' + money(v ? v.price : p.price) + '</span>' +
      picker +
      '<button type="button" class="vdc-pdp-rec__add" data-variant="' + escA(v ? v.id : '') + '">Add</button>' +
      '</div>';
  }

  function init() {
    var mount = document.getElementById('vdc-pdp-recs');
    if (!mount || mount.dataset.vdcDone === '1') return;
    mount.dataset.vdcDone = '1';
    var pid = mount.getAttribute('data-product-id');
    if (!pid) return;

    fetch(root + 'recommendations/products.json?product_id=' + pid + '&intent=related&limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var recs = ((data && data.products) || []).filter(function (p) {
          if (String(p.id) === String(pid)) return false;
          if (!p.available || !avail(p).length) return false;
          if (EXCLUDE.indexOf(p.handle) !== -1) return false;
          return true;
        }).slice(0, 6);
        if (!recs.length) return;
        mount.innerHTML = '<p class="vdc-pdp-recs__heading">You May Also Like</p>' +
          '<div class="vdc-pdp-recs__list">' + recs.map(card).join('') + '</div>';
      }).catch(function () {});

    mount.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.vdc-pdp-rec__add');
      if (!btn) return;
      var rec = btn.closest('.vdc-pdp-rec');
      var sel = rec && rec.querySelector('.vdc-pdp-rec__variant');
      var variantId = sel ? sel.value : btn.getAttribute('data-variant');
      if (!variantId || busy[variantId]) return;
      busy[variantId] = true;
      btn.disabled = true;
      var prev = btn.textContent;
      btn.textContent = 'Adding...';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function (r) {
        btn.textContent = r.ok ? 'Added' : 'Try again';
        if (!r.ok) { btn.disabled = false; }
        setTimeout(function () { btn.textContent = prev; btn.disabled = false; }, 2500);
      }).catch(function () { btn.textContent = prev; btn.disabled = false; });
      setTimeout(function () { delete busy[variantId]; }, 1600);
    });

    mount.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('.vdc-pdp-rec__variant');
      if (!sel) return;
      var rec = sel.closest('.vdc-pdp-rec');
      var opt = sel.options[sel.selectedIndex];
      if (rec && opt) {
        var price = rec.querySelector('.vdc-pdp-rec__price');
        var add = rec.querySelector('.vdc-pdp-rec__add');
        if (price && opt.dataset.price != null) price.textContent = money(opt.dataset.price);
        if (add) add.setAttribute('data-variant', sel.value);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
